import React, {useEffect, useRef, useState} from "react";
import {connect} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import * as formatter from "../../../../config/formatter";
import {getDetailCurrentDaySaleSt, getMaxBillNo, putSaleData} from "../../../../api/api";
import {Loading} from "../../../../components/common";
import {
    CButton,
    CCol,
    CForm,
    CFormInput,
    CFormLabel,
    CFormSelect,
    CFormText,
    CInputGroup,
    CInputGroupText
} from "@coreui/react";
import StoreCornerListWhere from "../../where/StoreCornerListWhere";
import PopupStoreCornerListWhere from "../../where/PopupStoreCornerListWhere";
import * as o2Api from "../../../../api/api";
import dayjs from "dayjs";
import {gridColumnAvg, gridColumnSum} from "../../../../config/common";

const PopupSaleRegister = () => {
    const gridRef = useRef();
    const saleGridRef = useRef();
    const [params] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const queryList = [...params];

    const [searchForm, setSearchForm] = useState({
        saleDt: queryList[0][1],
        cmpCd: queryList[1][1],
        brandCd: queryList[2][1],
        storeCd: queryList[3][1],
        posCd: queryList[4][1]
    });
    const [saleDtList, setSaleDtList] = useState([]);
    const [cashAmt, setCashAmt] = useState("0");
    const [cardAmt, setCardAmt] = useState("0");
    const [productList, setProductList] = useState([]);

    useEffect(() => {

    }, [searchForm.storeCd])

    const defaultColDef = {
        width: 100,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true
    };

    const [productColumnDefs] = useState([
        {field: "restProductCd", headerName: "상품코드"},
        {field: "productNm", headerName: "상품명", width: 200},
        {field: "sourceCd", headerName: "바코드", width: 150},
        {headerName: "가격구분", valueFormatter: (e) => "정가상품", cellClass: "static-cell"},
        {field: "payAmt", headerName: "원가단가", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
        {field: "price", headerName: "판매단가", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
    ]);

    const [saleDtColumnDefs] = useState([
		{field: "productCd", hide: true},
		{field: "restProductCd", headerName: "상품코드"},
		{field: "productNm", headerName: "상품명", width: 200},
		{field: "salePrice", headerName: "판매가", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
		{field: "saleQty", headerName: "수량", editable: true, valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
		{field: "saleAmt", headerName: "매출액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
		{field: "dcAmt", headerName: "할인액", editable: true, valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
		{field: "payAmt", headerName: "실매출액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
		{field: "vatAmt", headerName: "VAT", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"
		},
	])

    const [totalRowData] = useState([
        {restProductCd: "합계"}
    ])

    const createTotalRowData = (data) => {
        const api = saleGridRef.current.api;
        const result = [];
        result.push({
            restProductCd: "합계",
            saleQty: gridColumnSum(data, "saleQty"),
            saleAmt: gridColumnSum(data, "saleAmt"),
            dcAmt: gridColumnSum(data, "dcAmt"),
            payAmt: gridColumnSum(data, 'payAmt'),
            vatAmt: gridColumnSum(data, 'vatAmt'),
        });
        api.setPinnedBottomRowData(result);
    };

	const handleSelect = (code, value) => {
		if (value === "C") {
			setSearchForm((state) => ({...state, cmpCd: code}));
		} else if (value === "B") {
			setSearchForm((state) => ({...state, brandCd: code}));
		} else if (value === "S") {
			setSearchForm((state) => ({...state, storeCd: code}));
		} else if (value === "O") {
			setSearchForm((state) => ({...state, cornerCd: code}));
		}
	};

    const onClose = () => {
        window.close();
    }

    const onInit = () => {
        setSaleDtList([]);
    }

    const onSave = () => {
        if (confirm("수기매출을 등록하시겠습니까?")) {
            const saleHd = {};
            const dtList = [];
            const stList = [];
            let totalAmount = 0;
            let totalDcAmount = 0;
            let totalSaleQty = 0;
            // 총금액 = cashAmt + cardAmt, saleDtList 의 payAmt 합
            const totalStAmount = parseInt(cashAmt ? cashAmt : "0") + parseInt(cardAmt ? cardAmt : "0");
            let totalDtAmount = 0;
            let tradeType = "0";
            saleDtList.map((item) => {
                totalDtAmount += (item.salePrice * item.saleQty) - item.dcAmt;
            })
            if(totalStAmount < 0){
                tradeType = "2";
            }

            // 가격비교
            if (totalStAmount !== totalDtAmount) {
                alert("가격 정보를 다시 확인해주세요.\n(결제금액 : " + totalStAmount + ", 상품금액 : " + totalDtAmount + ")");
                return;
            }
            else {
                setLoading(true);
                // 영수증 번호 가져오기
                const {saleDt, cmpCd, brandCd, storeCd, posCd} = searchForm;
                const params = {
                    saleDt: saleDt, cmpCd: cmpCd, brandCd: brandCd, storeCd: storeCd, posCd: posCd
                }
                getMaxBillNo(params).then((result) => {
                    const { responseBody, responseCode, responseMessage } = result.data;
                    if (responseCode === "200") {
                        console.log("### Last Bill No :: ", responseBody);
                        let billNo = responseBody;
                        // 수기매출 영수증번호는 9XXXX 대역으로 생성한다.
                        if (billNo === "0" || billNo < "90000") {
                            billNo = "90001";
                        }
                        else {
                            billNo = parseInt(billNo) + 1;
                        }

                        const saleStList = [];
                        if (cashAmt!==null && cashAmt!== "" && cashAmt !== "0") saleStList.push({payDiv: "10", saleAmt: cashAmt});
                        if (cardAmt!==null && cardAmt!== "" && cardAmt !== "0") saleStList.push({payDiv: "20", saleAmt: cardAmt});

                        const currentTimestamp = dayjs().format('x');
                        const trxnNo = dayjs().format("YYMMDDHHmmssSSS");


                        // SaleDt
                        for (let i=0; i<saleDtList.length; i++) {
                            const saleDtItem = saleDtList[i];
                            const saleAmt = saleDtItem.salePrice * saleDtItem.saleQty;
                            const payAmt = saleAmt - parseInt(saleDtItem.dcAmt);
                            const vat = Math.round(payAmt - (payAmt / 1.1));

                            totalAmount += saleAmt;
                            totalDcAmount += parseInt(saleDtItem.dcAmt);
                            totalSaleQty += parseInt(saleDtItem.saleQty);

                            const item = {
                                saleDt: saleDt,
                                cmpCd: cmpCd,
                                brandCd: brandCd,
                                storeCd: storeCd,
                                posCd: posCd,
                                billNo: billNo,
                                orderNo: "",
                                saleSeq: i,
                                addedSeq: 0,
                                productCd: saleDtItem.productCd,
                                tradeType: tradeType,
                                trxnNo: trxnNo,
                                subProductDiv: "1",
                                freeDiv: "0",
                                dcDiv: "0",
                                saleTime: currentTimestamp,
                                salePrice: parseInt(saleDtItem.salePrice),
                                saleQty: parseInt(saleDtItem.saleQty),
                                saleAmt: saleAmt,
                                dcRate: 0,
                                dcAmt: parseInt(saleDtItem.dcAmt),
                                campaignCd: "",
                                campaignDcAmt: 0,
                                payAmt: payAmt,
                                netAmt: payAmt - vat,
                                vatRate: 10,
                                vatAmt: vat
                            };
                            dtList.push(item);
                        }

                        // SaleSt
                        for (let i=0; i<saleStList.length; i++) {
                            const saleStItem = saleStList[i];
                            const payAmt = parseInt(saleStItem.saleAmt);
                            const vat = (Math.round(payAmt - (payAmt / 1.1)));

                            saleStItem.saleDt			= saleDt;
                            saleStItem.cmpCd 			= cmpCd;
                            saleStItem.brandCd 			= brandCd;
                            saleStItem.storeCd 			= storeCd;
                            saleStItem.posCd			    = posCd;
                            saleStItem.billNo           = billNo;
                            saleStItem.paymentSeq		= i;
                            saleStItem.tradeType		= tradeType;
                            saleStItem.trxnNo			= trxnNo;
                            saleStItem.payDiv			= saleStList[i].payDiv;
                            saleStItem.curcDiv			= "10";
                            saleStItem.bcmpCode			= "FF";
                            saleStItem.bcmpName			= "수기결제";
                            saleStItem.ccmpCode			= "";
                            saleStItem.ccmpName			= "수기결제";
                            saleStItem.cardCd			= "";
                            saleStItem.cardNo			= "";
                            saleStItem.cardExp			= "";
                            saleStItem.cardInstal		= "00";
                            saleStItem.ingType			= "A";
                            saleStItem.appNo			    = "";
                            saleStItem.appTime			= "";
                            saleStItem.payAmt			= payAmt;
                            saleStItem.netAmt			= payAmt - vat;
                            saleStItem.vatRate			= 10;
                            saleStItem.vatAmt			= vat;
                            saleStItem.recvAmt			= payAmt;
                            saleStItem.changeAmt		= 0;
                            saleStItem.remainAmt		= 0;
                            saleStItem.etc1Char			= "";
                            saleStItem.etc2Char			= "";
                            saleStItem.saleTime			= currentTimestamp;
                            saleStItem.etc3Num			= 0;
                            saleStItem.etc4Num			= 0;
                            saleStItem.etc5Num			= 0;
                            saleStItem.state			= "9";

                            stList.push(saleStItem);
                        }

                        saleHd.saleDt 		= saleDt;
                        saleHd.cmpCd 			= cmpCd;
                        saleHd.brandCd 		= brandCd;
                        saleHd.storeCd 		= storeCd;
                        saleHd.posCd			= posCd;
                        saleHd.billNo           = billNo;
                        saleHd.cashierId		= "";
                        saleHd.trxnNo			= trxnNo;
                        saleHd.tradeType		= tradeType;
                        saleHd.rtnCode		= "";
                        saleHd.saleType		= "2";
                        saleHd.saleTime		= currentTimestamp;
                        saleHd.tableNo		= "";
                        saleHd.possTableCnt	= 0;
                        saleHd.custNo			= "";
                        saleHd.custSex		= "";
                        saleHd.custAge		= 0;
                        saleHd.custCnt		= 1;
                        saleHd.saleQty		= totalSaleQty;
                        saleHd.saleAmt		= totalAmount;
                        const payAmt = totalAmount - totalDcAmount
                        saleHd.payAmt			= payAmt;
                        saleHd.payAmtVat		= (Math.round(payAmt - (payAmt / 1.1)));
                        saleHd.dcAmt			= totalDcAmount;
                        saleHd.svcAmt			= 0;
                        saleHd.svcAmtVat		= 0;
                        saleHd.fcnt			= 0;
                        saleHd.mcnt			= 0;
                        saleHd.deliCd			= "";
                        saleHd.saleDtVoid		= "";
                        saleHd.billNoVoid		= "";
                        saleHd.hdorderMemo	= "";
                        saleHd.state			= "9";
                        saleHd.platformCd		= "P";
                        saleHd.saleDtList 	= dtList;
                        saleHd.saleStList		= stList;
                        saleHd.instTime		= currentTimestamp;
                        saleHd.updTime		= currentTimestamp;

                        console.log(">>> saleHd :: ", saleHd);

                        putSaleData([saleHd]).then((result) => {
                            const { responseBody, responseCode, responseMessage } = result.data;
                            if (responseCode === "200") {
                                if (responseBody != null) {
                                    console.log(">>> response :: ", responseBody);
                                    alert("수기매출 처리가 완료되었습니다.");

                                    setLoading(false);
                                    onClose();
                                }
                            }
                        })
                    }
                })
                    .catch((e) => {
                        setLoading(false);
                        alert("매출 등록 중 문제가 발생했습니다.\n" + e.message);
                    })
            }
        }
    }

    const search = () => {
		const {cmpCd, brandCd, storeCd, cornerCd} = searchForm;
		if (cornerCd.length === 0) {
			alert("조회시 코너는 반드시 선택해주세요.");
			return;
		}

		// 조회 조건에 따라 분기
		setLoading(true);
		// cmpCd 는 필수
		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			cornerCd: cornerCd,
			productNm: searchForm.productNm,
			restProductCd: searchForm.restProductCd,
			barcode: searchForm.barcode,
			isUse: "Y"
		};
		o2Api.getProductByCorner(params).then((result) => {
			const { responseBody, responseCode, responseMessage } = result.data;
			if (responseCode === "200") {
				if (responseBody != null) {
					console.log(">>> response :: ", responseBody);
					setProductList(responseBody);
				}
			}
			setLoading(false);
		});
	}

	const onRowDoubleClicked = (e) => {
    	// saleDt 용 데이터 생성
		const saleDt = {
			saleDt: searchForm.saleDt,
			cmpCd: searchForm.cmpCd,
			brandCd: searchForm.brandCd,
			storeCd: searchForm.storeCd,
			cornerCd: searchForm.cornerCd,
			posCd: searchForm.posCd,
			productCd: e.data.productCd,
			restProductCd: e.data.restProductCd,
			productNm: e.data.productNm,
			salePrice: e.data.price,
			saleQty: 1,
            saleAmt: e.data.price * 1,
            payAmt: e.data.price * 1,
			dcAmt: 0,
            vatAmt: e.data.price * 1 - (e.data.price * 1 / 1.1)
		}
		const dataList = saleDtList.concat(saleDt);
        createTotalRowData(dataList);
		setSaleDtList(dataList);
	}

	const onCellValueChanged = (e) => {
    	console.log(">>> e :: ", e);
    	// 수량을 0으로 할 경우 삭제
		const colId = e.column.colId;
		if (colId === "saleQty") {
			if (e.newValue === "0") {
				console.log("### row 삭제");
				saleGridRef.current.api.applyTransaction({
					remove: [e.node.data]
				})
                saleDtList.splice(e.node.id, 1);
			}
		}

		// 재계산
        console.log(">>> dataList :: ", saleDtList);
		saleDtList.map((item) => {
		    item.saleAmt = item.salePrice * item.saleQty;
		    item.payAmt = item.saleAmt - item.dcAmt;
		    item.vatAmt = item.payAmt - (item.payAmt / 1.1)
        })
        saleGridRef.current.api.setRowData(saleDtList);
        createTotalRowData(saleDtList);
	}

    return (
        <>
            <div style={{padding: 16}}>
                {loading ? <Loading/> : null}
                <div className={"d-grid gap-1 d-md-flex justify-content-between"}
                     style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#13319b"}}>
                    <span style={{color: 'white', fontWeight: 600}}>상품선택</span>
                    <div className="d-grid gap-1 d-md-flex justify-content-md-end">
                        <CButton size={"sm"} color="dark" onClick={onClose}>닫기</CButton>
                    </div>
                </div>
                <PopupStoreCornerListWhere type={"O"} selected={searchForm} onSelect={(c, v) => handleSelect(c, v)}/>
                <CForm className={"row row-cols-md-auto g-1 align-items-center p-1"}>
                    <CCol xs={12}>
                        <CInputGroup size={"sm"}>
                            <CInputGroupText style={{width: 70}}>상품코드</CInputGroupText>
                            <CFormInput id="productCd"
                                        onChange={(e) => {
                                            setSearchForm((state) => ({
                                                ...state,
                                                restProductCd: e.target.value
                                            }));
                                        }}/>
                        </CInputGroup>
                    </CCol>
                    <CCol xs={12}>
                        <CInputGroup size={"sm"}>
                            <CInputGroupText style={{width: 80}}>상품명</CInputGroupText>
                            <CFormInput id="productNm"
                                        onChange={(e) => {
                                            setSearchForm((state) => ({
                                                ...state,
                                                productNm: e.target.value
                                            }));
                                        }}/>
                        </CInputGroup>
                    </CCol>
                    <CCol xs={12}>
                        <CInputGroup size={"sm"}>
                            <CInputGroupText style={{width: 80}}>바코드</CInputGroupText>
                            <CFormInput id="barcode"
                                        onChange={(e) => {
                                            setSearchForm((state) => ({
                                                ...state,
                                                barcode: e.target.value
                                            }));
                                        }}/>
                        </CInputGroup>
                    </CCol>
                    <CButton size={"sm"} color={"primary"} onClick={search}>조회</CButton>
                </CForm>
                <div className="ag-theme-alpine" style={{width: "100%", height: 250, marginTop: 10}}>
                    <AgGridReact
                        ref={gridRef}
                        rowSelection={"single"}
                        headerHeight={30}
                        rowHeight={30}
                        rowData={productList}
                        animateRows={true}
						onRowDoubleClicked={onRowDoubleClicked}
                        defaultColDef={defaultColDef}
                        columnDefs={productColumnDefs}>
                    </AgGridReact>
                </div>

                <div className={"m-2"}/>

                <div className="d-grid gap-1 d-md-flex justify-content-md-between" style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#13319b"}}>
                    <span style={{color: 'white', fontWeight: 600}}>영업일자 : [{dayjs(searchForm.saleDt).format("YYYY-MM-DD")}] 포스번호 [{searchForm.posCd}]]</span>
                    <div className="d-grid gap-1 d-md-flex justify-content-md-end">
                        <CButton size={"sm"} color="dark" onClick={onInit}>초기화</CButton>
                    </div>
                </div>
                <div className="d-grid gap-1 p-1 d-md-flex justify-content-md-between">
                    <div>
                        <h6><span style={{color: "red"}}>*</span>수기매출 집계처리에 약 1분의 시간이 소요됩니다. 연속으로 등록되지 않습니다.</h6>
                        <h6><span style={{color: "red"}}>*</span>상품을 삭제하시려면 수량에 0을 입력하세요.</h6>
                    </div>
                    <div className="d-grid gap-1 d-md-flex justify-content-md-end">
                        <CForm>
                            <CInputGroup size="sm">
                                <CInputGroupText style={{width: 70}}>현금</CInputGroupText>
                                <CFormInput id="cash" value={cashAmt} onChange={(e) => setCashAmt(e.target.value)}/>
                                <CInputGroupText style={{width: 70}}>카드</CInputGroupText>
                                <CFormInput id="card" value={cardAmt} onChange={(e) => setCardAmt(e.target.value)} />
                                <button type="button" className="btn btn-primary" onClick={onSave}>저장</button>
                            </CInputGroup>
                        </CForm>
                    </div>
                </div>
                <div className="ag-theme-alpine" style={{width: "100%", height: 250, marginTop: 10}}>
                    <AgGridReact
                        ref={saleGridRef}
                        headerHeight={30}
                        rowHeight={30}
                        rowData={saleDtList}
                        animateRows={true}
						onCellValueChanged={onCellValueChanged}
                        pinnedBottomRowData={totalRowData}
                        defaultColDef={defaultColDef}
                        columnDefs={saleDtColumnDefs}>
                    </AgGridReact>
                </div>
            </div>
        </>
    )
}

export default connect(null, null)(PopupSaleRegister);